export default function AddAnotherButton({ label, onClick }) {
  return (
    <button type="button" className="add-another-btn" onClick={onClick}>
      <span aria-hidden="true" style={{ fontSize: 16, lineHeight: 1 }}>
        +
      </span>
      <span>{label}</span>
    </button>
  )
}
